module.exports = __webpack_public_path__ + "static/media/tally.a8609ba3.pdf";